// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"DashSpinner_spinnerWrapper__kd8uz","placeholder":"DashSpinner_placeholder__KLa1S","spinner":"DashSpinner_spinner__UqTQL","visible":"DashSpinner_visible__7Im8p"};